import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Header } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import Button from '../../../../../components/Button';
import CompanyDropdown from '../../../../../components/Dropdown/CompanyDropdown';
import getCompanyManagement from '../../../../../services/getCompanyManagement';

const MappingModal = ({ 
    adminId, 
    recruiterData, 
    isVerifyLoading, 
    onClose,
    adminEmail,
    onMapCompany 
}) => {
    const [selectedCompany, setSelectedCompany] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleModalSubmit = async () => {
        try {
            if (!selectedCompany.id) {
                toast.error('Please select a company');
                return;
            }

            setSubmitLoading(true);

            await onMapCompany(selectedCompany.id, adminEmail);
            onClose();
        } catch (err) {
            console.error('Failed to map recruiter to company', err);
            toast.error('Failed to map recruiter to company');
        } finally {
            setSubmitLoading(false);
        }
    };

    useEffect(() => {
        const getCompanyDetails = async () => {
            try{
                if (recruiterData.companyId) {

                    const companyDataResponse = await getCompanyManagement(adminId, {
                        id: recruiterData.companyId
                    });

                    if (companyDataResponse && companyDataResponse.data && companyDataResponse.data.data && companyDataResponse.data.data.companies && companyDataResponse.data.data.companies.length > 0) {
                        const company = companyDataResponse.data.data.companies[0];
                        setSelectedCompany({
                            id: recruiterData.companyId,
                            name: `${company.name} (${recruiterData.companyId})`
                        });            
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        getCompanyDetails();
    }, []);

    return (
        <Modal open={true} onClose={onClose}>
            <Header content={`Map Recruiter: ${recruiterData.name}`} />
            <Modal.Content>
                <div className="companyDropdown">
                    <div>Select the company to map the recruiter: </div>
                    <CompanyDropdown
                        adminId={adminId}
                        selectedCompany={selectedCompany.name}
                        onCompanySelect={(id, label) => setSelectedCompany({
                            id,
                            name: label
                        })}
                    />
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    clickButton={handleModalSubmit}
                    skin="light"
                    text="Submit"
                    loading={submitLoading}
                />
                <Button
                    clickButton={onClose}
                    skin="light" 
                    text="Close"
                />
            </Modal.Actions>
        </Modal>
    );
};

MappingModal.propTypes = {
    adminId: PropTypes.string.isRequired,
    recruiterData: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        unverifiedCompanyId: PropTypes.number,
        companyId: PropTypes.number
    }).isRequired,
    isVerifyLoading: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    adminEmail: PropTypes.string.isRequired,
    onMapCompany: PropTypes.func.isRequired,
};

export default MappingModal;